const Header = () => import('@/components/channel/Header/index');
const Footer = () => import('@/components/channel/Footer/index');
const channelHome = () => import('@/views/channel/channelHome.vue');
const channelHistory = () => import('@/views/channel/channelHistory.vue');
const channelMy = () => import('@/views/technician/techMy.vue');
const channelConsume = () => import('@/views/channel/channelConsume.vue');
const channelIndex = () => import('@/views/channel/channelIndex.vue');

export default [
    {
        path: '/channelHome',
        name: 'channelHome',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '当前任务',
        },
        components: {
            default: channelHome,
            header:Header,
            footer:Footer,
        }
    },
    {
        path: '/channelHistory',
        name: 'channelHistory',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '历史任务',
        },
        components: {
            default: channelHistory,
            header:Header,
            footer:Footer,
        }
    },
    {
        path: '/channelMy',
        name: 'channelMy',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '我的',
        },
        components: {
            default: channelMy,
            header:Header,
            footer:Footer,
        }
    },
    {
        path: '/channelConsume',
        name: 'channelConsume',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:true,
            title: '热敏纸记录',
        },
        components: {
            default: channelConsume,
            header:Header,
            footer:Footer,
        }
    },{
        path: '/channelIndex',
        name: 'channelIndex',
        meta: {
            keepAlive: true,
            login: true,
            iconLeft:false,
            title: '热敏纸管理',
        },
        components: {
            default: channelIndex,
            header:Header,
            footer:Footer,
        }
    },
];




